import { render, staticRenderFns } from "./DocTabs.vue?vue&type=template&id=134fe994&scoped=true&"
import script from "./DocTabs.vue?vue&type=script&lang=js&"
export * from "./DocTabs.vue?vue&type=script&lang=js&"
import style0 from "./DocTabs.vue?vue&type=style&index=0&id=134fe994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134fe994",
  null
  
)

export default component.exports